import {Component, Input} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";

/**
 * Generated class for the ProfileForgotPasswordPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-profile-forgot-password',
    templateUrl: 'profile-forgot-password.html',
})
export class ProfileForgotPasswordPage {

    errors: {};
    loading: boolean = false;
    emailSent: boolean = false;

    @Input() email: string;

    constructor(public navCtrl: NavController, private http: HttpClient, private apiErrorHandler: ApiErrorHandlerProvider) {
    }

    reset() {
        this.loading = true;

        this.http.post('/password/email', {
            email: this.email
        }).subscribe(res => {
            this.errors = {};
            this.loading = false;
            this.emailSent = true;
        }, error => {
            this.loading = false;
            this.errors = this.apiErrorHandler.handleError(error);
        })
    }
}



// WEBPACK FOOTER //
// ./src/pages/profile-forgot-password/profile-forgot-password.ts